<script>
import { mapGetters } from 'vuex'
import access from '@/lib/access.js'

export default {
  computed: {
    ...mapGetters(['account']),
  },

  methods: {
    getChecklistPermissions(checklistSiteId) {
      const isSiteAdmin = this.account?.isSiteAdmin
      const isRoutineManager = this.account?.isRoutineManager
      const isOrgAdmin = access?.isOrganizationAdmin?.(this.account)
      const isCoach = this.account?.isCoach ?? false

      const canUpdateAndDisable =
        (isSiteAdmin || isRoutineManager) &&
        this.account?.site?._id === checklistSiteId

      return {
        create: isRoutineManager || isSiteAdmin || isOrgAdmin,
        delete: canUpdateAndDisable || isOrgAdmin,
        edit: canUpdateAndDisable || isOrgAdmin,
        makeGlobal: isOrgAdmin,
        download: isSiteAdmin || isOrgAdmin || isCoach,
      }
    },
  },
}
</script>
